import hasSpecialChars from "./hasSpecialChars";

const validateVinNo = (value) => {
  let error = "";

  if (!value) {
    error = "Please fill out this field";
  } else if (hasSpecialChars(value)) {
    error = "No special characters allowed";
  } else if (value.length < 17 || value.length > 17) {
    error = "Length must be 17";
  } else {
    const str = value.toLowerCase();
    if (str.includes("i") || str.includes("o") || str.includes("q")) {
      error = "Cannot contain I, O or Q";
    }
  }

  return error;
};

export default validateVinNo;
